import {HookClass, Hook, BaseHook, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {Observable, of, from} from 'rxjs';
import {HttpHook} from '../http/http.hook';
import {concatMap, map} from 'rxjs/operators';
import * as QRCode from 'qrcode';

@HookClass('qrcode')
export class QrCodeHook extends BaseHook {

    @Hook('fcb46c42-1eda-421e-9e59-8ba255dd8b5a')
    public generateQrCode(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return from(QRCode.toDataURL(inputArtifact.object.data))
            .pipe(map((qrCodeUrl: string) => {
                const outputArtifact = new NickProcessArtfact();
                outputArtifact.kind = ArtfactKind.ANY;
                outputArtifact.object = qrCodeUrl;
                return outputArtifact;
            }));
    }
}
